import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
import "./ProgramsBanner.css";
 
// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};
 
const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
 
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};
 
// Renamed component
const BioMedicalWasteManagement = () => {
  // Data for the initiatives section for cleaner code
  const initiatives = [
    "Developing models for hospital waste management (e.g., NALCO hospital).",
    "Providing consultancy and training for industrial houses.",
  ];
 
  const { openDonation } = useDonation();
  const navigate = useNavigate();
 
  return (
    <>
      <Header />
 
      {/* Hero Section */}
      <section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/Bio-Medical.png)",
          }}
        ></div>
        <div className="shape1 float-bob-x">
          <img src="assets/images/shapes/page-header-shape1.png" alt="" />
        </div>
        <div className="shape2">
          <img src="assets/images/shapes/page-header-shape2.png" alt="" />
        </div>
        <Container>
          <div className="page-header__inner text-center">
            <motion.h2
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Bio-Medical Waste Management
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              style={{ color: "#dad2d0", fontSize: "22px", marginTop: "20px" }}
            >
              Vikash supports biomedical waste management initiatives by promoting safe, efficient disposal and treatment of medical waste to protect public health and the environment.
            </motion.p>
          </div>
        </Container>
      </section>
 
      {/* Introduction Section (REFRESHED UI) */}
      <section className="py-5" style={{ background: "linear-gradient(180deg, rgba(240,251,245,0.98), rgba(255,255,255,0.95))" }}>
        <Container>
          <style>{`
            .bmwm-intro-wrap{max-width:1220px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:32px;align-items:center}
            .bmwm-intro-panel{background:#fff;border-radius:38px;padding:42px 44px;box-shadow:0 40px 120px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.12);position:relative;overflow:hidden}
            .bmwm-intro-panel::before{content:'';position:absolute;top:-20px;right:-20px;width:220px;height:220px;border-radius:50%;background:rgba(15,122,58,0.08);filter:blur(16px);pointer-events:none}
            .bmwm-eyebrow{display:inline-flex;align-items:center;gap:10px;padding:12px 18px;border-radius:999px;background:rgba(15,122,58,0.14);color:#0f7a3a;font-weight:700;font-size:.95rem;margin-bottom:20px}
            .bmwm-title{font-family:Poppins, sans-serif;font-size:3rem;font-weight:800;color:#0f7a3a;line-height:1.04;margin-bottom:24px}
            .bmwm-copy{color:#234038;font-size:1.05rem;line-height:1.9;max-width:720px}
            .bmwm-badges{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;margin-top:34px}
            .bmwm-badge{padding:18px 20px;border-radius:24px;background:#eef7ef;color:#0f7a3a;font-weight:700;box-shadow:0 18px 40px rgba(15,122,58,0.06)}
            .bmwm-media{position:relative;display:flex;flex-direction:column;align-items:center;gap:24px}
            .bmwm-media::before{content:'';position:absolute;top:-20px;left:-20px;width:220px;height:220px;border-radius:34px;background:rgba(15,122,58,0.12);z-index:0}
            .bmwm-card{position:relative;z-index:1;border-radius:36px;overflow:hidden;box-shadow:0 34px 105px rgba(15,122,58,0.16);border:1px solid rgba(255,255,255,0.8);width:100%}
            .bmwm-card img{display:block;width:100%;height:auto;object-fit:cover}
            .bmwm-card-overlay{position:absolute;bottom:24px;left:24px;background:rgba(255,255,255,0.92);border-radius:24px;padding:16px 18px;box-shadow:0 24px 58px rgba(0,0,0,0.08);max-width:320px}
            .bmwm-card-overlay span{display:block;color:#0f7a3a;font-weight:700;font-size:.82rem;margin-bottom:8px}
            .bmwm-card-overlay p{margin:0;color:#2e5044;font-size:.95rem;line-height:1.7}
            .bmwm-info-panel{width:100%;background:#fff;border-radius:32px;padding:28px 30px;box-shadow:0 24px 72px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08)}
            .bmwm-info-panel h3{margin:0 0 14px;color:#0f7a3a;font-size:1.6rem;font-weight:800}
            .bmwm-info-panel ul{margin:0;padding:0;list-style:none;display:grid;gap:14px}
            .bmwm-info-panel li{display:flex;align-items:flex-start;gap:12px;color:#334d42;font-size:.98rem;line-height:1.75}
            .bmwm-info-panel li::before{content:'•';color:#1f8f4d;font-size:1.2rem;line-height:1}
            @media(max-width:980px){.bmwm-intro-wrap{grid-template-columns:1fr}.bmwm-badges{grid-template-columns:1fr}.bmwm-media{flex-direction:column}}
          `}</style>
 
          <div className="bmwm-intro-wrap">
            <div className="bmwm-intro-panel">
              <div className="bmwm-eyebrow">Biomedical Waste Safety</div>
              <h2 className="bmwm-title">Safe Medical Waste Management with Precision</h2>
              <p className="bmwm-copy">
                Vikash has developed and implemented a model for bio-medical waste management in the 50-bedded NALCO hospital in Damanjodi. We provide consultancy and training for industrial houses and work alongside the World Bank and the Government of Odisha to ensure safe disposal and compliance with medical waste regulations.
              </p>
              <div className="bmwm-badges">
                <div className="bmwm-badge">Hospital waste handling systems</div>
                <div className="bmwm-badge">Regulatory & compliance training</div>
              </div>
            </div>
 
            <div className="bmwm-media">
              <div className="bmwm-card">
                <img src="/assets/images/sections/BMWM.jpg" alt="Bio-medical waste management system" />
                <div className="bmwm-card-overlay">
                  <span>Health-safe disposal</span>
                  <p>Operational and training practices designed to protect patients, staff, and the environment.</p>
                </div>
              </div>
              <div className="bmwm-info-panel">
                <h3>Key Biomedical Waste Focus Areas</h3>
                <ul>
                  <li>Hospital waste segregation and safe collection protocols.</li>
                  <li>Waste treatment design for clinical and industrial facilities.</li>
                  <li>Training programs for staff and waste management teams.</li>
                  <li>Consultancy support for World Bank and Odisha government initiatives.</li>
                </ul>
              </div>
            </div>
          </div>
        </Container>
      </section>
 
      {/* Structured Initiatives Section */}
      <section className="py-5" style={{ background: "#ffffff" }}>
        <Container>
          <style>{`
            .bmwm-initiative-wrap{max-width:1220px;margin:0 auto;display:grid;grid-template-columns:1fr 0.95fr;gap:32px;align-items:start}
            .bmwm-initiative-panel{background:#f6fcf7;border-radius:34px;padding:36px 40px;box-shadow:0 32px 92px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08)}
            .bmwm-initiative-panel h2{margin:0 0 18px;color:#0f7a3a;font-size:2.1rem;font-weight:800}
            .bmwm-initiative-panel p{margin:0;color:#334d42;font-size:1rem;line-height:1.8}
            .bmwm-initiative-list{display:grid;gap:22px;margin-top:28px}
            .bmwm-initiative-card{display:grid;grid-template-columns:72px 1fr;gap:20px;align-items:flex-start;background:#fff;border-radius:28px;padding:28px 30px;box-shadow:0 18px 54px rgba(15,122,58,0.08);transition:transform .3s ease,box-shadow .3s ease}
            .bmwm-initiative-card:hover{transform:translateY(-6px);box-shadow:0 28px 78px rgba(15,122,58,0.14)}
            .bmwm-step-circle{width:72px;height:72px;border-radius:24px;background:linear-gradient(180deg,#0f7a3a,#1f8f4d);display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:1.3rem}
            .bmwm-initiative-copy{color:#243d35;font-size:1rem;line-height:1.75}
            .bmwm-side-image{display:flex;flex-direction:column;align-items:flex-start;position:relative;gap:24px}
            .bmwm-side-image::before{content:'';position:absolute;top:-20px;right:-20px;width:120px;height:120px;border-radius:30px;background:rgba(15,122,58,0.08);filter:blur(18px);}
            .bmwm-side-image img{position:relative;z-index:1;width:100%;max-width:520px;border-radius:32px;box-shadow:0 26px 80px rgba(15,122,58,0.12)}
            .bmwm-side-cards{display:grid;grid-template-columns:1fr 1fr;gap:18px;width:100%}
            .bmwm-side-card{background:#fff;border-radius:28px;padding:22px 24px;box-shadow:0 18px 54px rgba(15,122,58,0.08);border:1px solid rgba(15,122,58,0.08);color:#263f35;line-height:1.75;min-height:130px;display:flex;align-items:center;justify-content:center;text-align:center;font-size:0.98rem}
            @media(max-width:980px){.bmwm-initiative-wrap{grid-template-columns:1fr}.bmwm-initiative-panel{padding:28px 24px}.bmwm-initiative-list{grid-template-columns:1fr}.bmwm-side-cards{grid-template-columns:1fr}}
          `}</style>
 
          <div className="bmwm-initiative-wrap">
            <div className="bmwm-initiative-panel">
              <h2>Our Management Models & Technologies</h2>
              <p>We focus on creating sustainable and locally-adapted biomedical waste solutions.</p>
              <div className="bmwm-initiative-list">
                {initiatives.map((initiative, index) => (
                  <div key={index} className="bmwm-initiative-card">
                    <div className="bmwm-step-circle">{index + 1}</div>
                    <div className="bmwm-initiative-copy">{initiative}</div>
                  </div>
                ))}
              </div>
            </div>
 
            <div className="bmwm-side-image">
              <img src="/assets/images/sections/BMWM.jpg" alt="Bio-medical waste management system" />
              <div className="bmwm-side-cards">
                <div className="bmwm-side-card">
                  Clinical waste treatment design for hospitals and healthcare facilities.
                </div>
                <div className="bmwm-side-card">
                  Comprehensive staff training and compliance support for waste handlers.
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
 
      {/* Call To Action Section (Reusable) */}
      <section className="py-5 text-dark" style={{ backgroundColor: "#ffffffff" }}>
        <Container className="text-center">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
          >
            <h2 className="display-5 fw-bold mb-3">Support Public Health & Safety</h2>
            <p className="lead mb-4">
              Your contribution helps us develop and implement safe bio-medical waste management systems to protect our communities.
            </p>
            <Button variant="dark" size="lg" className="me-3 fw-bold" onClick={openDonation}>
              Donate
            </Button>
            <Button variant="outline-dark" size="lg" className="fw-bold" onClick={() => navigate("/interns")}>
              Join Us
            </Button>
          </motion.div>
        </Container>
      </section>
 
      <Footer />
 
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
 
export default BioMedicalWasteManagement;
 